import createSagaMiddleware from 'redux-saga';
import combineSectionReducers from 'combine-section-reducers';
import {
  GlobalPut,
  integrateReduxDevtoolsExtension,
  NgRefreshStore,
  PS20Store,
} from '@ps20-frontend/shop-integration-redux';
import {
  gesamtbeitragMitRabattReducer,
  gesamtbeitragReducerForApp,
  jahresbeitragReducer,
  rabattstufeReducer,
} from '@ps20-frontend/reducers';
import { App } from '@ps20-frontend/frontend-models';
import { configureStore, Dispatch, Middleware, Tuple, UnknownAction } from '@reduxjs/toolkit';
import { IAppState } from './appState';
import { rootReducer } from './reducers/rootReducer.reducer';
import { rootSaga } from './sagas/rootSaga';
import { INITIAL_STATE } from './initialState';
import { risikoortReducer } from './reducers/risikoort.reducer';
import { versicherungsnehmerReducer } from './reducers/versicherungsnehmer.reducer';
import { transientStateReducer } from './reducers/transient-state.reducer';
import { rsVermietungProduktReducer } from './reducers/produkt.reducer';
import { rsVermietungVertragsoptionenReducer } from './reducers/vertragsoptionen.reducer';
import { rsVermietungTaasInfoReducer } from './reducers/rsVermietungTaasInfo.reducer';
import { antragsnummerReducer } from './reducers/antragsnummer.reducer';
import { adressvorschlagReducer } from './reducers/adressvorschlag.reducer';
import { rechtsstreitigkeitenReducer } from './reducers/rechtsstreitigkeitenReducer';
import { vermieterCardReducer } from './reducers/vermieterCard.reducer';

export const reducers = combineSectionReducers({
  version: (version: number = null) => version,
  risikoort: risikoortReducer,
  transientState: transientStateReducer,
  versicherungsnehmer: versicherungsnehmerReducer,
  adressvorschlag: adressvorschlagReducer,
  produkt: rsVermietungProduktReducer,
  vertragsoptionen: rsVermietungVertragsoptionenReducer,
  taasInfo: rsVermietungTaasInfoReducer,
  rabattstufe: rabattstufeReducer,
  antragsnummer: antragsnummerReducer,
  gesamtbeitragMitRabatt: gesamtbeitragMitRabattReducer,
  gesamtbeitrag: gesamtbeitragReducerForApp(App.RS_VERMIETUNG),
  jahresbeitrag: jahresbeitragReducer,
  rechtsstreitigkeiten: rechtsstreitigkeitenReducer,
  vermieteteCardObjekte: vermieterCardReducer,
});

export function storeFactory(initialState: IAppState): PS20Store<IAppState> {
  const ngRefreshStore = new NgRefreshStore<IAppState>(App.RS_VERMIETUNG);
  const sagaMiddleware = createSagaMiddleware();
  const store = configureStore({
    reducer: rootReducer(reducers),
    devTools: integrateReduxDevtoolsExtension('rs-vermietung-angebot-gui'),
    preloadedState: initialState,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware().concat(sagaMiddleware, ngRefreshStore.ngRefreshMiddleware) as unknown as Tuple<ReadonlyArray<Middleware<Record<string, never>, IAppState, Dispatch<UnknownAction>>>>,
  });
  sagaMiddleware.run(rootSaga);
  ngRefreshStore.setDelegate(store);
  return ngRefreshStore;
}

export const localStore: PS20Store<IAppState> = storeFactory(INITIAL_STATE);

GlobalPut.getInstance().globalEventDispatcherFunction = () => {
  return localStore.globalEventDispatcherRef;
};
